import React, { Component } from 'react';
import {actions, connect} from 'mirrorx';
import classNames from 'classnames';

class SidebarTOC extends Component {
	constructor() {
		super();
		this.state = {
			toc: [],
			text: ''
		}

		this.processTOC = this.processTOC.bind(this);
	}
	processTOC() {
		let toc = [];
		let lines = this.state.text.split(/\r?\n/);
		for (let i = 0; i < lines.length; i++) {
			let line = lines[i];
			if (/^\.[A-Z a-z](.)*$/.test(line)) {
				const entry = {
					text: line.substring(1),
					level: 1,
					type: 'fountain',
					line: i,
					key: i
				};
				toc.push(entry);
				continue;
			}
			if (/^# (.)+$/.test(line)) {
				const entry = {
					text: line.substring(2),
					level: 1,
					type: 'markdown',
					line: i,
					key: i
				}
				toc.push(entry);
				continue;
			}
			if (/^## (.)+$/.test(line)) {
				const entry = {
					text: line.substring(3),
					level: 2,
					type: 'markdown',
					line: i,
					key: i
				}
				toc.push(entry);
				continue;
			}

			if (/^### (.)+$/.test(line)) {
				const entry = {
					text: line.substring(3),
					level: 3,
					type: 'markdown',
					line: i,
					key: i
				}
				toc.push(entry);
				continue;
			}

		}

		this.setState({
			toc: toc
		});
	}

	jumpToLine(line) {
		actions.editor.jumpToLine(line);
	}

	componentWillReceiveProps(nextProps) {
		
		this.setState({
			text: nextProps.editor.text
		});
		this.processTOC();
	}

	render() {
		return <ul className='sidebar-toc-ul'>
			{this.state.toc.map((item) => {
				return <li 
					className={classNames('sidebar-toc-li', 'sidebar-toc-li-level'+item.level)}
					onClick={this.jumpToLine.bind(this, item.line)} 
					key={item.key}><span className='sidebar-toc-small'>{item.line+1}</span> {item.text}</li>
			})}
		</ul>
	}
}

export default connect(state => {
  return {editor: state.editor}
}, null, null, { withRef: true })(SidebarTOC)


// WEBPACK FOOTER //
// ./src/components/sidebar-toc.js